import { CSSProperties, useState } from 'react'
import { Typography } from '@arco-design/web-react'
import cls from 'classnames'
import useLocale from '@/utils/useLocale'
import styles from './index.module.less'

export default function Introduction({
  contentHtml,
  containerClassName,
  containerStyle,
  defaultIsExpand = false
}: {
  contentHtml: string
  containerClassName?: string
  containerStyle?: CSSProperties
  defaultIsExpand?: boolean
}) {
  const t = useLocale()
  const [isExpand, setIsExpand] = useState(defaultIsExpand)

  return (
    <div className={styles['introduction']} style={containerStyle}>
      <span
        dangerouslySetInnerHTML={{
          __html: contentHtml
        }}
        className={cls(styles.line, {
          [styles.lineExpand]: isExpand
        })}
      />
      {/* <Typography.Text
        copyable={{
          text: contentStr
        }}
      ></Typography.Text> */}
      <div
        className={cls(styles.more, {
          [styles.moreExpand]: isExpand
        })}
        onClick={() => {
          setIsExpand(!isExpand)
        }}
      >
        {isExpand ? t['introduction.collapse'] : t['introduction.expand']}
      </div>
    </div>
  )
}
